var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{staticClass:"insight-customer-feedback-popup",attrs:{"back-action":_vm.backActionClicked,"buttons":_vm.buttons,"title":'נשמח לדעת מה לא היה נכון כדי שנוכל להשתפר'},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('text-area',{attrs:{"autofocus":true,"value":"","on-input":_vm.handleInput}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }